export default {
  CheckConnection: 0,
  FindMate: 1,
  Pause: 2,
  Engaged: 3,
  Married: 4,
};
